export default __webpack_public_path__ + "static/media/upRightArrow.165d7bc8.png";